import { useMutation } from 'react-query';

import { useOrganization } from '@context/OrganizationContext';
import { useVendor } from '@context/VendorContext';
import { useSnackbar } from '@goodfynd/context';
import type { CreateStripeAccountResponse } from '@services/api/types';

import { useOrganizationApi } from '@hooks/api';

export default function useConnectStripe() {
  const { openSnackbar } = useSnackbar();
  const api = useOrganizationApi();

  const { organizationId } = useOrganization();
  const { vendorId } = useVendor();

  const { mutateAsync: connectStripe, isLoading: busy } = useMutation<
    CreateStripeAccountResponse,
    Error
  >(() => api.createStripeAccount(organizationId, vendorId), {
    onError(error) {
      openSnackbar({
        type: 'error',
        message: error.message ?? 'An unknown error has occurred',
      });
    },
    onSuccess(data) {
      if (!data?.onboardingLink) {
        return;
      }

      window.open(data.onboardingLink, '_self');
    },
  });

  return {
    busy,
    connectStripe,
  };
}
